import { Box, Grid, Typography } from "@mui/material";
import BaseButton from "../../BaseButton";

export default function OpenExternalModal({ close, data }) {
  const { width, onConfirm = () => {}, loadingConfirm = false } = data

  const handleClickConfirm = async () => {
    if (onConfirm) {
      await onConfirm()
    }
    close()
  }

  return (
    <Box sx={{
      width: '512px',
      maxWidth: width,
      borderRadius: '16px',
      boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
    }}>
      <Box sx={{
        padding: '40px'
      }}>
        <Box
          sx={{
            mb: '32px'
          }}
        >
          <Typography 
            variant="h2"
          >
            This will open an external website
          </Typography>
        </Box>
        <Box
          sx={{
            mb: '32px'
          }}
        >
          <Typography 
            variant="body"
          >
            This will now open an external website that is not operated by descendantsDNA. Please click continue to open the site or cancel to return.
          </Typography>
        </Box>
        <Grid container spacing={'32px'}>
          <Grid item xs={6}>
            <BaseButton
              height={'43px'}
              bgColor={'#ABB7C0'}
              sx={{
                border: '0px solid',
                borderRadius: '100px',
                background: '#ABB7C0',
                color: 'white',
              }}
              onClick={close}
            >
              Cancel
            </BaseButton>
          </Grid>
          <Grid item xs={6}>
            <BaseButton
              buttonType="primary"
              height={'43px'}
              sx={{
                border: '0px solid',
                borderRadius: '100px',
              }}
              onClick={handleClickConfirm}
              loading={loadingConfirm}
            >
              Continue
            </BaseButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}